<template>
  <section v-if="!isPageLoading" class="learning-paths">
    <div class="learning-paths__header">
      <h4 class="content-type">Learning Paths</h4>
      <p class="content-description">
        INE Learning Paths provide a clear trajectory through certain
        certification tracks, ensuring that you're watching the right videos and
        learning the vital topologies necessary to pass your exams.
      </p>
    </div>
    <div class="learning-paths__paths-wrapper">
      <LearningPathTile
        v-for="path in learningPaths"
        :key="path.id"
        :path="path"
        :backgroundImg="$getPlaylistBackground(path.id)"
        :duration="path.duration"
        :difficulty="
          path.difficulties && path.difficulties.data[0]
            ? path.difficulties.data[0].rating
            : 0
        "
        :customClass="'result-course'"
      ></LearningPathTile>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import LearningPathTile from '../components/layout/LearningPathTile.vue'

export default {
  name: 'LearningPaths',
  computed: {
    ...mapGetters({
      isPageLoading: 'app/isPageLoading',
      learningPaths: 'learningPaths/learningPaths',
    }),
  },
  components: {
    LearningPathTile,
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    await this.$store.dispatch('learningPaths/getLearningPaths')
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss">
.learning-paths {
  padding: 150px 25px 0 25px;
  @include tablet {
    padding: 150px 75px;
  }
  &__paths-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 auto;
    width: 100%;
  }
  .content-description {
    width: 100%;
    margin: 0 0 50px 0;
    font-size: 1.3rem;
    @include tablet {
      width: 65%;
    }
  }
  .result-course {
    width: 100%;
    padding: 5px;
    @include tablet {
      width: 50%;
    }
    @include desktop {
      width: 25%;
    }
    @include lg-desktop {
      width: 15%;
    }
  }
}
</style>
